import { useUserStore } from "@/stores/react";
import { FullscreenButton } from "./FullscreenButton";

/** 头部右侧区域，展示全屏操作和当前用户名称。 */
export function ToolBarRight() {
    const userName = useUserStore(state => state.userInfo.user?.name || "");

    return (
        <div className="tool-bar-right">
            <div className="header-icon">
                <FullscreenButton />
            </div>
            <div className="header-user-name">{userName}</div>
        </div>
    );
}

export default ToolBarRight;
